export default {
  templateHeader: {
    title: '克隆音色资产',
    desc: '为角色克隆自定义音色，获得更接近真人的配音效果。',
    addVoice: '新增克隆音色',
  },
  table: {
    confirmDelete: {
      message: '删除后无法恢复，确认删除吗？',
      title: '删除音色',
    },
    runningAlert: '正在添加音色，请稍候。',
    action: {
      stop: '停止',
      play: '播放',
      edit: '编辑',
    },
    added: '已添加',
  },
  addVoice: {
    form: {
      sample: '音频样本',
      separation: '同时移除背景音乐',
      name: '名称',
      namePlaceholder: '请输入',
      desc: '描述',
      descPlaceholder:
        '请描述这个音色。例如“一个年长的美国男性声音，喉咙略带嘶哑，非常适合新闻播报。”',
      upload: {
        asset: '点击从库里添加',
        tip_1:
          '理想的音频时长为1-2分钟（不少于1秒），清晰且无混响、瑕疵或背景噪音。（支持音频、视频）',
        tip_2:
          '音频质量是影响克隆效果最重要的因素，包括声音本身、语言、口音和录音质量。',
        tip_3: '保持音频一致性，确保整个过程中音调和表现保持稳定。',
        tip_4: '音量适中，理想范围在-23 dB至-18 dB RMS，真实峰值为-3 dB。',
        formatError: '文件格式不支持',
        durationError: '时长需大于 {s}s，请重新上传。',
      },
      edit: '编辑音色',
      confirm: '新增',
    },
    disabledTips: {
      usedSlot: '已添加的克隆音色数量已达上限。',
      voiceEdit: '本月克隆音色编辑次数已耗尽。',
    },
  },
}
